export default class AlertRequestQuery {
  //this class would be an interface but a class could be useful for more advance filtration of alert keys
  public typeSelector!: any; //used to get filter type selector. this can also refer to the Notice key (although it may not be recommendable to trust it, as not all notices are consistent with their keys).
  public name!: any; //alert name, if known already, pass along, this is all that is needed.
  public replacements!: {} | undefined; //replacements is an object that maps a string to another, to be used in string replace of errorsBag.alertResponses.

  public event!: any; //when passing an input event, must have a target property.
  public index!: Number | undefined; //index would be used for stack of notices, an identifier or anything useful for later uses.

  public constructor(init?: Partial<AlertRequestQuery>) {
    if (init) {
      if (init instanceof AlertRequestQuery) {
        Object.assign(this, init);
      } else {
        this.event = init.event ? init.event : undefined;
        this.name = init.name ? init.name : undefined;
        this.typeSelector = init.typeSelector ? init.typeSelector : undefined;
        this.index = init.index ? init.index : undefined;
        this.replacements = init.replacements ? init.replacements : undefined;
      }
    } else {
      this.event = undefined;
      this.name = undefined;
      this.typeSelector = undefined;
      this.index = undefined;
      this.replacements = undefined;
    }
  }

  public getKey(keyList: Array<string>, filter: any = null): AlertRequestQuery {
    //fill this as a helper to filter the alert names by type
    //pass to this ValidationModule alertNames and alertTypes
    // ALWAYS return an object of itself with name property
    if (this.name) {
      return this;
    } else if (this.event && this.event.target.value) {
    } else if (this.index) {
    } else if (this.replacements) {
    }
    //to get the key:
    //if event has target or something, return that after filter... event needs to be checked to see what is being sent from search
    //if name is string, return that key after filter
    //if index, to be determine
    //if replacements, pass along

    //make a map of keyList, searching for key and filter, then return
    return this; //return ALWAYS have to return an object with name property
  }
}
